import { useAuth0 } from "@auth0/auth0-react";

import { getWieldyOrgId, USE_AUTH } from "../api/apiConfig";

const PROD_DEMO_ORG_ID = "org_7SJoIL6FiCkCl7yn";

const useDevMode = (): boolean => {
  const { user } = useAuth0();
  const { search } = window.location;
  const userIsAuthorized =
    !USE_AUTH || [PROD_DEMO_ORG_ID, getWieldyOrgId()].includes(user?.org_id);
  return new URLSearchParams(search).has("devmode") && userIsAuthorized;
};

export default useDevMode;
export { PROD_DEMO_ORG_ID };
